/**
 * 功能: 对解说视频的播放
 */
<template lang="pug">
  el-dialog(:visible.sync="dialogVisible" width="60%" destroy-on-close @close="dialogVisible = false" :close-on-click-modal="false" :before-close="closeDialog" height="500")
    .prism-player#J_prismPlayer

</template>

<script>
import { getPlayUrl } from '@/apis/video'

export default {
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    // 根据视频的vid执行播放
    show (vid) {
      this.dialogVisible = true
      getPlayUrl({ vid }).then(res => {
        if (res.errCode === 0) {
          this.$nextTick(() => {
          // eslint-disable-next-line
          new Aliplayer({
              id: 'J_prismPlayer',
              width: '100%',
              height: '600px',
              autoplay: true,
              vid,
              playauth: res.data.playauth,
              encryptType: 1 // 当播放私有加密流时需要设置
            })
          })
        } else {
          return this.$message({ type: 'error', message: '视频正在准备，请稍后再试' })
        }
      }).catch(err => {
        console.log(err)
        this.$message({ type: 'error', message: '获取播放地址失败！' })
      })
    },
    closeDialog () {
      this.dialogVisible = false
    }
  }
}

</script>

<style lang="postcss" scoped>
  @import 'https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css';
</style>
